import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { SessionService } from 'app/sessions/session.service';
import { UserService } from 'app/users/shared/user.service';
import { GridDataResult, RowClassArgs, PageChangeEvent } from '@progress/kendo-angular-grid';
import { DateService } from 'app/date/date.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HRMSService } from '../shared/hrms.service';
import { filterBy } from '@progress/kendo-data-query';
import { IOption } from 'ng-select';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { UtilService } from '../shared/util.service';
export const activeTab = {
  tab : "tab1"
};
@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./payroll.component.scss'],
  animations: [fadeInOutTranslate],
})
export class PayrollComponent implements OnInit {
  netSalary:number;
  employees:any;
  public pageSize = 10;
  public skip = 0;
  public gridView: GridDataResult;
  @ViewChild("SalaryModal") SalaryModal;
  @ViewChild("ProcessSalaryModal") ProcessSalaryModal;
  @ViewChild("tabRef") tabRef;
  myForm:FormGroup;
  employeesOptions:Array<any>;
  searchForm:FormGroup;
  otherForm:FormGroup;
  other:any;
  uid:any;
  searchResult:any;
  isSearch:boolean = false;
  designationOptions:Array<IOption>;
  branchOptions: Array<IOption>;
  salaryListToProcess:any;
  date = new Date();
  selectedMonth:any = this.date.getMonth();
  currentMonth:any;
  public gridDataToPdf: any[];
  @ViewChild("OtherModal") OtherModal;
  overtimeOptions: Array<IOption> = [
    {label: 'Over Time' , value: 'Over Time'},
    {label: 'Travelling Allowance' , value: 'Travelling Allowance'},
    {label: 'Other' , value: 'Other'}
  ];
  yearOptions: Array<IOption> = [];
  editMonth:any;
  editYear:any;
  monthOptions: Array<IOption> = [];
  grossSalary:Number = 0;
  lossOfPay:Number = 0;
  constructor(private ss:SessionService, private userService:UserService, private dateService:DateService, private hrmsService:HRMSService, private nf:NotificationToastService,private ls:LogisticsService,
     private util:UtilService) {
     }

  ngOnInit() {
    this.initializeForm();
    this.getYearOptions();
    this.getAllEmployees();
    this.getAllDesignations();
    this.getAllBranch();
    this.other  = [];
    this.salaryListToProcess = [];
    this.date = new Date();
    this.selectedMonth = this.date.getMonth();
    this.currentMonth = this.date.getMonth();
    this.util.monthOptions.forEach(m=>{
      if(Number(m.value) <= this.currentMonth + 1)
      this.monthOptions.push(m);
    });
    //console.log("activetab",activeTab.tab);
    if(activeTab.tab == "tab2")
    {
      this.tabRef.activeId = activeTab.tab;
    }
  }
  initializeForm()
  {
    this.myForm = new FormGroup({
      basic: new FormControl(''),
      da: new FormControl(''),
      hra: new FormControl(''),
      conveyance: new FormControl(''),
      allowance: new FormControl(''),
      medicalAllowance: new FormControl(''),
      others: new FormControl(''),
      pf: new FormControl(''),
      tds: new FormControl(''),
      tax: new FormControl(''),
      lossofpay: new FormControl(''),
      leaves: new FormControl(''),
      overtime: new FormControl('')
    });

    this.searchForm  = new FormGroup({
      name: new FormControl('All'),
      branch: new FormControl(''),
      designation: new FormControl(''),
      year: new FormControl(''),
      from: new FormControl(''),
      to: new FormControl(''),
    });
    this.searchForm.reset();
    this.searchForm.get('name').setValue("All");
    this.searchForm.get('year').setValue(String(this.date.getFullYear()));
    this.searchForm.get('from').setValue(String(this.date.getMonth()+1));
    this.otherForm = new FormGroup({
      name: new FormControl('',Validators.required),
      value: new FormControl('',Validators.required)
    });
  }
  getYearOptions()
  {
    var i = 0;
    while(i < 10)
    {
      var year = 2019+i;
      if(year <= this.date.getFullYear())
      {
        this.yearOptions.push({label: String(year), value: String(year)});
      }
      else
      {
        break;
      }
      i++;
    }
  }
  getAllEmployees()
  {
    this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
      this.employees = [];
      this.employeesOptions = [];
      this.employeesOptions.push({label: "All", value: "All"});
      data.forEach((user)=>{
        if(user.payload.child("role").val() != 'customer')
        {
          var u = user.payload.val();
          var date = new Date();
          var tableData = u;
          tableData.id = user.key;
          tableData.joiningDate = this.dateService.getJoiningDate(u.joiningDate),
          tableData.month = date.getMonth()+1;
          tableData.year = date.getFullYear();

          this.hrmsService.getSalary(date.getMonth()+1,date.getFullYear(),user.key).on("value", (data)=>{
            tableData.computedSalary = data.child("computedSalary").val()?data.child("computedSalary").val():u.salary;
            tableData.status = data.child("status").val()?data.child("status").val():"Pending";
            tableData.lastUpdatedOn = data.child("lastUpdatedOn").val();
            tableData.salaryComponent = data.val()
          });
          this.employees.push(tableData);
          this.employeesOptions.push({label: String(u.name), value: String(u.employeeId)});
        }
      });
      this.loadItems();
  });
}
private loadItems():void{
  this.gridDataToPdf = [];
  if(this.isSearch)
  {
    this.gridDataToPdf = this.searchResult;
    this.gridView = {
      data: this.searchResult.slice(this.skip, this.skip + this.pageSize),
      total: this.searchResult.length
    };
  }
  else{
    this.gridDataToPdf = this.employees;
    this.gridView = {
      data: this.employees.slice(this.skip, this.skip + this.pageSize),
      total: this.employees.length
    };
  }
}
  private calculateSalary(data)
  {
    var gross = data.basic + Number(data.hra?data.hra:0) + Number(data.da?data.da:0) + Number(data.others?data.others:0) + Number(data.medicalAllowance?data.medicalAllowance:0)
    + Number(data.allowance?data.allowance:0) + Number(data.conveyance?data.conveyance:0) + Number(data.overtime?data.overtime:0);
    //Deduction
    var deduction = Number(data.pf?data.pf:0) + Number(data.tax?data.tax:0) + Number(data.tds?data.tds:0);
    //console.log("gross",gross,deduction);
    //Net Salary
    this.netSalary = gross - deduction;
    this.netSalary = Number(Number(this.netSalary).toFixed(2));
    //Loss Of Pay
    var perDay = Number(this.netSalary) / 31 ;
    var lossofpay = 0;
    if(data.leaves)
    {
      lossofpay =  Number((perDay * Number(data.leaves)).toFixed(2));
    }
    this.netSalary = this.netSalary - lossofpay;
    this.netSalary = Number(Number(this.netSalary).toFixed(2));
  }
  onSubmit()
  {
    this.calculateSalary(this.myForm.value);
    this.saveUserDetails(this.myForm.value);
  }
  saveUserDetails(data)
  {
    data.computedSalary = this.netSalary;
    data.date = this.dateService.getTodaysDate();
    data.lastUpdatedOn = this.dateService.getTodaysDate() +", "+this.dateService.getTimeandDate().time;
    data.status = "Pending";
    data.uid  = this.uid;
    data.grossSalary = this.grossSalary;
    data.lossOfPay = this.lossOfPay;
    this.hrmsService.updateSalary(Number(this.editMonth),this.editYear,this.uid,data).then(()=>{
      this.SalaryModal.hide();
      this.myForm.reset();
      this.hrmsService.disbleProcessSalary(this.date.getFullYear()+"-"+(this.date.getMonth()+1));
      this.nf.addToast({title:'Salary Updated', msg:'Salary successfully updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
      this.getAllEmployees();
    });
  }
  public edit(salaryData)
  {
    this.SalaryModal.show();
    this.myForm.reset();
    this.uid = salaryData.id;
    this.editMonth = salaryData.month;
    this.editYear = salaryData.year;
      this.myForm.get('basic').setValue(salaryData.basic);
      this.myForm.get('da').setValue(salaryData.da?salaryData.da:0);
      this.myForm.get('hra').setValue(salaryData.hra?salaryData.hra:0);
      this.myForm.get('conveyance').setValue(salaryData.conveyance?salaryData.conveyance:0);
      this.myForm.get('allowance').setValue(salaryData.allowance?salaryData.allowance:0);
      this.myForm.get('medicalAllowance').setValue(salaryData.medicalAllowance?salaryData.medicalAllowance:0);
      this.myForm.get('others').setValue(salaryData.others?salaryData.others:0);
      this.myForm.get('pf').setValue(salaryData.pf?salaryData.pf:0);
      this.myForm.get('tds').setValue(salaryData.tds?salaryData.tds:0);
      this.myForm.get('tax').setValue(salaryData.tax?salaryData.tax:0);
      if(salaryData.salaryComponent != null)
      {
        this.myForm.get('leaves').setValue(salaryData.salaryComponent.leaves?salaryData.salaryComponent.leaves:0);
        this.myForm.get('overtime').setValue(salaryData.salaryComponent.overtime?salaryData.salaryComponent.overtime:0);
      }
      this.netSalary = salaryData.computedSalary?salaryData.computedSalary:salaryData.salary;
  }
  public onSubmitSearchNew()
{
  this.isSearch = true;
  var result = filterBy(this.employees, {
    logic: 'or',
    filters: [
        { field: "Name", operator: "eq", value: this.searchForm.value.name},
        { field: "Branch", operator: "eq", value: this.searchForm.value.branch},
        { field: "Designation", operator: "eq", value: this.searchForm.value.designation},
        { field: "From", operator: "eq", value: this.dateService.getJoiningDate(this.searchForm.value.from)},
        { field: "To", operator: "eq", value: this.dateService.getJoiningDate(this.searchForm.value.to)}
    ]
});
this.searchResult =  result;
this.loadItems();
}
public onSubmitSearchgg()
{
  this.isSearch = true;
  if(this.searchForm.value.from == null && this.searchForm.value.to == null)
  {
    var result = filterBy(this.employees, {
      logic: 'or',
      filters: [
          { field: "employeeId", operator: "eq", value: this.searchForm.value.name},
          { field: "branch", operator: "eq", value: this.searchForm.value.branch},
          { field: "designation", operator: "eq", value: this.searchForm.value.designation},
          { field: "from", operator: "eq", value: this.dateService.getJoiningDate(this.searchForm.value.from)},
          { field: "to", operator: "eq", value: this.dateService.getJoiningDate(this.searchForm.value.to)}
      ]
  });
  this.searchResult =  result;
  this.loadItems();
  } 
  else if(this.searchForm.value.from != null)
  {
    var year = this.searchForm.value.year?this.searchForm.value.year:this.date.getFullYear();
    var i = Number(this.searchForm.value.from);
    while(i <= Number(this.searchForm.value.to))
    {
      var resultData = [];
      this.hrmsService.getSelectedMonthSalary(this.searchForm.value.from,year).snapshotChanges().subscribe((data)=>{
        data.forEach((salaryData)=>{
            this.userService.getUser(salaryData.key).once("value", (data)=>{
              var u = data.val();
              var tableData = u;
              tableData.id = salaryData.key;
              tableData.joiningDate = this.dateService.getJoiningDate(u.joiningDate),
              tableData.month = i;
              tableData.year = year;

            this.hrmsService.getSalary(i,year,salaryData.key).on("value", (data)=>{
              tableData.computedSalary = data.child("computedSalary").val()?data.child("computedSalary").val():u.salary;
              tableData.status = data.child("status").val()?data.child("status").val():"Pending";
              tableData.lastUpdatedOn = data.child("lastUpdatedOn").val();
              tableData.salaryComponent = data.val()
            });
          this.employees.push(tableData);
          this.employeesOptions.push({label: String(u.name), value: String(u.employeeId)});
          resultData.push(tableData);
            });
            this.searchResult =  resultData;
            this.loadItems();
      });
    this.searchResult =  resultData;
    this.loadItems();
   });
   i++;
  }
  }
}
public onSubmitSearch()
{
  this.isSearch = true;
  if(this.searchForm.value.from != null)
  {
    this.searchResult = [];
    var year = this.searchForm.value.year?this.searchForm.value.year:this.date.getFullYear();
      //this.hrmsService.getSelectedMonthSalary(this.searchForm.value.from,year).snapshotChanges().subscribe((data)=>{
      var result = [];
      /* data.forEach((salaryData)=>{
          this.userService.getUser(salaryData.key).once("value", (data)=>{
            var u = data.val();
            if(u!=null)
            {
              var tableData = u;
              tableData.id = salaryData.key;
              tableData.joiningDate = this.dateService.getJoiningDate(u.joiningDate),
              tableData.month = this.searchForm.value.from;
              tableData.year = year;
              this.hrmsService.getSalary(this.searchForm.value.from,year,salaryData.key).once("value", (userData)=>{
                tableData.computedSalary = userData.child("computedSalary").val()?userData.child("computedSalary").val():u.salary;
                tableData.status = userData.child("status").val()?userData.child("status").val():"Pending";
                tableData.lastUpdatedOn = userData.child("lastUpdatedOn").val();
                tableData.salaryComponent = userData.val();
              });
            result.push(tableData);
            }
          });
    }); */
    this.employees.forEach((employee)=>{
    var u = employee;
    if(u!=null)
    {
      var tableData = u;
      /* tableData.id = employee.id;
      tableData.joiningDate = this.dateService.getJoiningDate(u.joiningDate),
      tableData.month = this.searchForm.value.from;
      tableData.year = year; */
      this.hrmsService.getSalary(this.searchForm.value.from,year,employee.id).once("value", (userData)=>{
        tableData.computedSalary = userData.child("computedSalary").val()?userData.child("computedSalary").val():u.salary;
        tableData.status = userData.child("status").val()?userData.child("status").val():"Pending";
        tableData.lastUpdatedOn = userData.child("lastUpdatedOn").val();
        tableData.salaryComponent = userData.val();
      });
    result.push(tableData);
    }
 });
    if(this.searchForm.value.name != "All" && this.searchForm.value.branch != null && this.searchForm.value.designation != null)
    {
      this.searchResult = [];
      this.searchResult = filterBy(result.length>0?result:this.employees, {
        logic: 'and',
        filters: [
            { field: "employeeId", operator: "eq", value: this.searchForm.value.name},
            { field: "branch", operator: "eq", value: this.searchForm.value.branch},
            { field: "designation", operator: "eq", value: this.searchForm.value.designation},
        ]
    });
    }
    else if(this.searchForm.value.name != "All" && this.searchForm.value.branch != null)
    {
      this.searchResult = [];
      this.searchResult = filterBy(result.length>0?result:this.employees, {
        logic: 'and',
        filters: [
            { field: "employeeId", operator: "eq", value: this.searchForm.value.name},
            { field: "branch", operator: "eq", value: this.searchForm.value.branch}
        ]
    });
    }
    else if(this.searchForm.value.name != "All" && this.searchForm.value.designation != null)
    {
      this.searchResult = [];
      this.searchResult = filterBy(result.length>0?result:this.employees, {
        logic: 'and',
        filters: [
            { field: "employeeId", operator: "eq", value: this.searchForm.value.name},
            { field: "designation", operator: "eq", value: this.searchForm.value.designation}
        ]
    });
    }
    else
    {
      if(this.searchForm.value.designation != null)
      {
        this.searchResult = [];
        this.searchResult = filterBy(result.length>0?result:this.employees, {
          logic: 'or',
          filters: [
              { field: "designation", operator: "eq", value: this.searchForm.value.designation}
          ]
      });
      }
      else if(this.searchForm.value.branch != null)
      {
        this.searchResult = filterBy(result.length>0?result:this.employees, {
          logic: 'or',
          filters: [
              { field: "branch", operator: "eq", value: this.searchForm.value.branch}
          ]
      });
      }
      else
      {
        if(String(this.currentMonth+1) == this.searchForm.value.from || this.searchForm.value.name === "All")
        {
          if(this.searchForm.value.name != "All")
          {
            this.searchResult = filterBy(this.employees, {
              logic: 'or',
              filters: [
                  { field: "employeeId", operator: "eq", value: this.searchForm.value.name}
              ]
          }); 
          }
          else if(String(this.currentMonth+1) == this.searchForm.value.from)
          {
            this.searchResult = this.employees;
          }
          else
          {
            this.searchResult = result;
          }
        }
        else
        {
          this.searchResult = filterBy(result, {
            logic: 'or',
            filters: [
                { field: "employeeId", operator: "eq", value: this.searchForm.value.name}
            ]
        });
        }
      }
      this.loadItems();
    }
//});
}
}
public getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
  this.designationOptions = [];
    item.forEach(element =>{
        this.designationOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
formControlName:any;
formControlArray:any = [];
overTime:any;
travellingAllowance:any;
onChange(event)
{
  this.formControlName = event.target.value;
  switch(event.target.value)
  {
    case 'overTime': this.overTime = {
      name: this.formControlName,
      label: "Over Time"
    };
    break;
    case 'travellingAllowance': this.travellingAllowance = {
      name: this.formControlName,
      label: "Travelling Allowance"
    };
    break;
    case 'other':
    this.formControlArray.push({
      name: this.formControlName+"1",
      label: "Other"
    });
    break;
  }
  
  this.myForm.addControl(this.formControlName+"1",new FormControl());
}
get formContol()
{
  return this.myForm.addControl(this.formControlName,new FormControl());
}
add()
{
  if(this.otherForm.valid)
  {
    this.OtherModal.hide();
    this.other.push(this.otherForm.value);
    this.formControlArray.push({
      name: this.otherForm.value.name,
      label: this.otherForm.value.name
    });
    this.myForm.addControl(this.otherForm.value.name,new FormControl(this.otherForm.value.value));
    this.otherForm.reset();
  }
  //console.log("other",this.other);
}
keyPressCalculateSalary()
{
  this.calculateSalary(this.myForm.value);
}
get Month()
{
  return this.dateService.getMonth(Number(this.searchForm.value.from)-1);
}
getAllBranch()
{
  this.ls.getBranch().snapshotChanges().subscribe(data=>{
    this.branchOptions  = [];
    data.forEach(branch=>{
      this.branchOptions.push({
        label: branch.payload.child("name").val(),
        value: branch.payload.key
      })
    });
  });
}
onChangeCheck(id)
{
  //console.log("change",id);
  if(!this.salaryListToProcess.includes(id))
  {
    this.salaryListToProcess.push(id);
  }
  else
  {
    //console.log("position",this.salaryListToProcess.indexOf(id));
    this.salaryListToProcess.splice(this.salaryListToProcess.indexOf(id),1);
  }
  //console.log("change",this.salaryListToProcess);
}
clearSearch()
{
  this.searchForm.reset();
  this.isSearch = false;
  this.searchForm.get('name').setValue("All");
  this.searchForm.get('year').setValue(String(this.date.getFullYear()));
  this.searchForm.get('from').setValue(String(this.date.getMonth()+1));
  this.loadItems();
}
public rowCallback = (context: RowClassArgs) => {
  var flag = context.dataItem.Salary != context.dataItem.ComputedSalary;
  switch (flag) {
    case true:
      return {gold : true};
    case false:
      return {green : true};
    default:
    return {};
   }
  }
  onClickMonthPaySlip(m)
  {
    this.selectedMonth = this.util.fullMonthNames.indexOf(m);
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
  }
  processSalaryOld()
  {
    this.hrmsService.checkSalaryProcessed(this.date.getFullYear(),this.date.getMonth()+1).once("value").then((data)=>{
      if(data.numChildren()>0)
      {
        this.nf.addToast({title:'Warning', msg:'Salary Already Processed', timeout: 5000, theme:'material', position:'bottom-right', type:'warning'});
        this.ProcessSalaryModal.hide();
      }
      else
      {
        this.hrmsService.updateSalaryForThisMonth(this.date.getFullYear(),this.date.getMonth()+1);
        this.nf.addToast({title:'Salary Processed', msg:'Salary successfully processed', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        this.ProcessSalaryModal.hide();
      }
    });
  }
  processSalary()
  {
    var child = this.date.getFullYear()+"-"+(this.date.getMonth()+1);
    this.hrmsService.checkSalaryProcessedForEmployee(child).once("value").then((data)=>{
      if(data.numChildren()>0)
      {
        this.nf.addToast({title:'Warning', msg:'Salary Already Processed for the month of '+this.util.fullMonthNames[this.date.getMonth()], timeout: 5000, theme:'material', position:'bottom-right', type:'warning'});
        this.ProcessSalaryModal.hide();
      }
      else
      {
        this.hrmsService.updateSalaryForThisMonth(this.date.getFullYear(),this.date.getMonth()+1);
        this.nf.addToast({title:'Salary Processed', msg:'Salary successfully processed', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        this.ProcessSalaryModal.hide();
      }
    });
  }
  onTabChange(id)
  {
    //console.log("id",id);
    activeTab.tab = id;
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/payroll/payroll.component.ts